import type { RouteRecordRaw } from "vue-router";

export const brandMallRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter/brandMall/shopManage",
		name: "ShopManage",
		meta: {
			title: "店铺管理",
			keepAlive: false,
		},
		component: () => import("@main/views/Apps/BrandMall/ShopManage/ShopManage.vue"),
	},
	{
		path: "/desktopCenter/brandMall/orderManage",
		name: "OrderManage",
		meta: {
			title: "订单管理",
			keepAlive: false,
		},
		component: () => import("@main/views/Apps/BrandMall/OrderManage/OrderManage.vue"),
	},
	{
		path: "/desktopCenter/brandMall/orderDetail",
		name: "OrderDetail",
		meta: {
			title: "订单详情",
			keepAlive: false,
			hideInMenu: true,
			activeMenu: "/desktopCenter/brandMall/orderManage",
		},
		component: () => import("@main/views/Apps/BrandMall/OrderDetail/OrderDetail.vue"),
	},
	{
		path: "/desktopCenter/brandMall/productList",
		name: "ProductList",
		meta: {
			title: "产品列表",
			keepAlive: false,
		},
		component: () => import("@main/views/Apps/BrandMall/ProductList/ProductList.vue"),
	},
	{
		path: "/desktopCenter/brandMall/editProduct",
		name: "EditProduct",
		meta: {
			title: "编辑产品",
			keepAlive: true,
			hideInMenu: true,
			activeMenu: "/desktopCenter/brandMall/productList",
		},
		component: () => import("@main/views/Apps/BrandMall/EditProduct/EditProduct.vue"),
	},
	{
		path: "/desktopCenter/brandMall/categorySettings",
		name: "BrandMallCategorySettings",
		meta: {
			title: "分类设置",
			keepAlive: false,
		},
		component: () => import("@main/views/Apps/BrandMall/CategorySettings/CategorySettings.vue"),
	},
	{
		path: "/desktopCenter/brandMall/specificationAttributes",
		name: "SpecificationAttributes",
		meta: {
			title: "规格属性",
			keepAlive: false,
		},
		component: () =>
			import("@main/views/Apps/BrandMall/SpecificationAttributes/SpecificationAttributes.vue"),
	},
	{
		path: "/desktopCenter/brandMall/offlineStores",
		name: "OfflineStores",
		meta: {
			title: "线下门店",
			keepAlive: false,
		},
		component: () => import("@main/views/Apps/BrandMall/OfflineStores/OfflineStores.vue"),
	},
];
